<template>
	<div class="shop_list">
		<Header2 :searchShow="false" :meauShow="false" pageTitle="专卖店查询"></Header2>
		<div class="sas_con">
			<div class="hd_search">
				<div class="se_box flex1">
					<input type="text" v-model="keyword" placeholder="全国专卖店查询" />
					<img @click="searchBtn" src="@/images/zoom2.png" />
				</div>
			</div>
			<div class="sp_head2 flex1">
				<div class="aph_d1 flex3">
					<span class="slt_tit">省份：</span>
					<select class="slt_box" @change="handlProChange">
						<option value="">不限</option>
						<option :value="item.storeProvinceCode" v-for="item in proList" :key="item.id" :selected="
                                proCode == item.storeProvinceCode ? true : false
                            ">
							{{ item.storeProvinceName }}
						</option>
					</select>
					<img class="dp1_right" src="@/images/right1.png" />
				</div>
				<div class="aph_d1 flex3">
					<span class="slt_tit">城市：</span>
					<select class="slt_box" @change="handlCityChange">
						<option value="">不限</option>
						<option :value="item.storeCityCode" v-for="item in cityList" :key="item.id">
							{{ item.storeCityName }}
						</option>
					</select>
					<img class="dp1_right" src="@/images/right1.png" />
				</div>
			</div>
			<div class="sp_box">
				<p class="sp_num">共{{ total }}条查询结果</p>
				<ul class="sp_ul">
					<li class="sp_li" v-for="(item, index) in splist" :key="index">
						<span class="sp_li_left">{{ index + 1 }}</span>
						<div class="sp_li_right">
							<p class="lrt_p1">{{ item.storeDoorHead }}</p>
							<p class="lrt_p2">
								{{ item.storeAddress }}
							</p>
							<p class="lrt_p3">{{ item.storeMainLinkmanTel }}</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			proList: [], //下拉显示的省份
			proList2: [], //包含字母的省份
			proCode: "",
			cityList: [],
			cityCode: "",
			keyword: "",
			splist: [],
			page: 0,
            total:0,
		};
	},
	created() {
		this.proCode = this.$route.query.procode;
		this.cityCode = this.$route.query.citycode || "";
		this.keyword = this.$route.query.keyword || "";
		if (this.proCode) {
			this.phoneshi(this.proCode);
		}
		this.mdstroe();
		this.phonesheng();
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	methods: {
		async phonesheng() {
			const res = await this.$api.phonesheng();
			if (res.code == 1) {
				this.proList2 = res.data;
				for (let i = 0; i < this.proList2.length; i++) {
					this.proList = this.proList.concat(
						this.proList2[i].storeProvinceName
					);
				}
			}
		},
		async phoneshi(a) {
			const res = await this.$api.phoneshi({
				storeProvinceCode: a,
			});
			if (res.code == 1) {
				if (res.data.length) {
					this.cityList = res.data;
				} else {
					this.cityList = [];
				}
			}
		},
		async mdstroe() {
			var data3 = {
				page: this.page,
				nums: 10,
				storeProvinceCode: this.proCode,
				storeCityCode: this.cityCode,
				keyword: this.keyword,
			};
			const res = await this.$api.mdstroe(data3);
            this.total = res.msg;
            if (res.data.length) {
                this.page++;
                this.splist = this.splist.concat(res.data);
            }else {
                if (this.page > 0) {
                    this.$message({
                        message: '没有更多啦！',
                        offset: 100,
                        duration: 2000
                    });
                }
            }
		},
		handlProChange(e) {
			this.proCode = e.target.value;
			this.phoneshi(this.proCode);
			this.cityCode = "";
			this.page = 0;
			this.splist = [];
			this.mdstroe();
		},
		handlCityChange(e) {
			this.cityCode = e.target.value;
			this.page = 0;
			this.splist = [];
			this.mdstroe();
		},
		searchBtn() {
			this.page = 0;
			this.splist = [];
			this.mdstroe();
		},
		handleScroll() {
			const windowHeight = window.innerHeight;
			const documentHeight = document.documentElement.scrollHeight;
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			if (windowHeight + scrollTop >= documentHeight) {
				this.mdstroe();
			}
		},
	},
};
</script>

<style lang="scss">
.shop_list {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	padding: 1.23rem 0 2.4rem 0;
	min-height: 90vh;
	background-image: url("../../images/bgimg3.png");
	.sas_con {
		.hd_search {
			padding: 0.4rem 0.53rem 0.47rem;
			.se_box {
				background-color: #fff;
				position: relative;
				height: 1.17rem;
				padding: 0 0.33rem;
				border-radius: 1.17rem;
				display: flex;
				justify-content: space-between;
				input {
					color: #666;
					font-size: 17px;
					width: 100%;
					height: 1.17rem;
					border-radius: 1.17rem;
					background-color: #fff;
					border: none;
					outline: none;
				}
				img {
					width: 0.45rem;
				}
			}
		}
		.sp_head2 {
			padding: 0 0.53rem;
			margin-bottom: 0.5rem;
			box-sizing: border-box;
			.aph_d1 {
				width: 50%;
				padding-right: 0.48rem;
				span {
					font-size: 17px;
					color: #666;
				}
				.slt_box {
					color: #333;
					font-size: 17px;
					-webkit-appearance: none;
					-moz-appearance: none;
					appearance: none;
					background: transparent;
					width: 40%;
					border: none;
					margin-bottom: 1px;
					outline: none;
					flex: 1;
				}
				.dp1_right {
					width: 8px;
					margin-left: 0.48rem;
				}
			}
		}
		.sp_box {
			padding: 0 0.53rem 0.8rem;
			.sp_num {
				font-size: 12px;
				color: #666;
				margin-bottom: 0.27rem;
				text-align: left;
			}
			.sp_ul {
				.sp_li {
					display: flex;
					background-color: #fff;
					padding: 0.4rem;
					padding-left: 0;
					margin-bottom: 0.27rem;
					align-items: flex-start;
					.sp_li_left {
						display: block;
						color: #ccc;
						font-size: 18px;
						width: 1.04rem;
						line-height: 24px;
						flex-shrink: 0;
						text-align: center;
					}
					.sp_li_right {
						flex: 1;
						.lrt_p1 {
							margin-bottom: 0.27rem;
							color: #000;
							font-size: 17px;
							font-weight: 700;
							text-align: left;
						}
						.lrt_p2 {
							color: #666;
							font-size: 12px;
							text-align: left;
						}
						.lrt_p3 {
							color: #666;
							font-size: 12px;
							margin-top: 0.13rem;
							text-align: left;
						}
					}
				}
			}
		}
	}
}
</style>